import { Shield, Lock, FileCheck, Eye } from "lucide-react"
import { useTranslation } from 'react-i18next'

const securityIcons = [
  <Lock size={20} className="text-green-600" />,
  <Shield size={20} className="text-green-600" />,
  <FileCheck size={20} className="text-green-600" />,
  <Eye size={20} className="text-green-600" />,
]

interface SecurityItem {
  title: string
  description: string
}

interface Badge {
  label: string
  sub: string
}

export default function SecuritySection() {
  const { t } = useTranslation()

  const items = t('landing.security.items', { returnObjects: true }) as SecurityItem[]
  const badges = t('landing.security.badges', { returnObjects: true }) as Badge[]

  return (
    <section id="security" className="py-20 bg-green-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p
              className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t('landing.security.sectionLabel')}
            </p>
            <h2
              className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t('landing.security.headline')}
            </h2>
            <p
              className="text-gray-600 dark:text-gray-300 text-base leading-relaxed mb-8"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t('landing.security.subheadline')}
            </p>

            <div className="space-y-5">
              {items.map((item, i) => (
                <div key={item.title} className="flex gap-4">
                  <div className="flex-shrink-0 w-9 h-9 bg-green-100 dark:bg-green-900/40 rounded-lg flex items-center justify-center">
                    {securityIcons[i]}
                  </div>
                  <div>
                    <h3
                      className="text-sm font-bold text-gray-900 dark:text-white mb-0.5"
                      style={{ fontFamily: "'DM Sans', sans-serif" }}
                    >
                      {item.title}
                    </h3>
                    <p
                      className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed"
                      style={{ fontFamily: "'DM Sans', sans-serif" }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {badges.map((badge) => (
              <div
                key={badge.label}
                className="bg-white dark:bg-gray-700 rounded-2xl p-6 text-center shadow-sm border border-green-100 dark:border-gray-600"
              >
                <div className="w-12 h-12 bg-green-100 dark:bg-green-900/40 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Shield size={22} className="text-green-600" />
                </div>
                <div
                  className="text-lg font-bold text-gray-900 dark:text-white"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {badge.label}
                </div>
                <div
                  className="text-sm text-gray-500 dark:text-gray-400"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {badge.sub}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
